// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  BackgroundLayerKind,
} from "./types";


export default __t.row({
  layerId: __t.string().primaryKey().name("layer_id"),
  name: __t.string(),
  description: __t.string(),
  get kind() {
    return BackgroundLayerKind;
  },
  sourceUrl: __t.string().name("source_url"),
  attribution: __t.string(),
  licenseNote: __t.string().name("license_note"),
  requiresApiKey: __t.bool().name("requires_api_key"),
  defaultEnabled: __t.bool().name("default_enabled"),
  maxZoom: __t.u32().name("max_zoom"),
  dailyRequestCap: __t.u32().name("daily_request_cap"),
  updatedAt: __t.timestamp().name("updated_at"),
});
